'use client'
import {useEffect, useState} from "react";
import ProductList from "@/app/components/pages/shop/ProductList";
import React from "react";
import Pagination from "@/app/components/common/Pagination";
import ProductFilter from "@/app/components/pages/shop/ProductFilter";
import {useRouter} from "next/navigation";

const ProductPagination = ({data, routePath, showCategoryFilter = true}) => {

    const [products, setProducts] = useState(data?.products ? data?.products.products : [])
    const [total, setTotal] = useState(data?.products ? data?.products.total : 0)
    const [filters, setFilters] = useState(data?.filters ? data?.filters : {})
    const router = useRouter()

    useEffect(() => {
        setProducts(data?.products ? data?.products.products : [])
        setTotal(data?.products ? data?.products.total : 0)
    }, [data])

    const onFilterChange = (data) => {

        const filterData = {
            ...filters,
            ...data,
            paged: 1
        }

        setFilters(filterData)
        fetchProducts(filterData)
    }

    const onPageChanged = (pageNumber) => {
        const filterData = {
            ...filters,
            paged: pageNumber
        }

        setFilters(filterData)
        fetchProducts(filterData)
        goTopOfPage();
    }

    const goTopOfPage = () => {
        window.scrollTo({top: 0, behavior: 'instant'});
    }

    const fetchProducts = (filters) => {

        const filtered = Object.fromEntries(
            Object.entries(filters).filter(([key, value]) => value != null)
        );

        const params = new URLSearchParams(filtered).toString();
        router.push(routePath + '?' + params);
    }

    return <>
        <ProductFilter
            data={data}
            routePath={routePath}
            onChange={onFilterChange}
            showCategoryFilter={showCategoryFilter}
        />

        <ProductList
            products={products}
        />

        <Pagination
            items={total}
            pageSize={process.env.NEXT_PUBLIC_PER_PAGE}
            currentPage={filters?.paged ? filters?.paged : 1}
            onPageChange={onPageChanged}
        />
    </>
}

export default ProductPagination
